module.exports = __webpack_public_path__ + "img/normal_box.99a1e9c5.png";